import { dataPuzzlePieceSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPuzzlePieceSolid = /*#__PURE__*/createIcon(dataPuzzlePieceSolid)
export default IconPuzzlePieceSolid
